import React, { type CSSProperties } from 'react';
import { Typography } from '@popmenu/common-ui';

import { classNames, withStyles, type WithStyles } from '../../../utils/withStyles';
import formGroupStyles from '../../../assets/jss/shared/formGroupStyles';

import { AH, AHLevelProvider } from '../../../consumer/shared/AccessibleHeading';

export interface FormGroupProps extends WithStyles<typeof formGroupStyles> {
  children: React.ReactNode;
  className?: string | null;
  dataCy?: string | null;
  dataTourId?: string | null;
  error?: React.ReactNode;
  errorId?: string;
  notice?: React.ReactNode;
  style?: CSSProperties;
  title?: React.ReactNode;
}

const FormGroup = ({
  children,
  classes,
  className = null,
  dataCy = null,
  dataTourId = null,
  error = null,
  errorId,
  notice = null,
  style,
  title = null,
}: FormGroupProps) => (
  <div
    className={classNames(
      'pm-form-group',
      className,
      classes.formGroup,
      error ? classes.formGroupError : null,
    )}
    data-cy={dataCy}
    data-tour-id={dataTourId}
    style={style}
  >
    {title && (
      <AH typography className={classes.title} gutterBottom variant="h6">
        {title}
      </AH>
    )}
    <AHLevelProvider>
      {children}
      {!error && notice && (
        <Typography className={classes.formGroupNoticeMessage} role="alert">
          {notice}
        </Typography>
      )}
      {error && (
        <Typography id={errorId} className={classes.formGroupErrorMessage} role="alert">
          {error}
        </Typography>
      )}
    </AHLevelProvider>
  </div>
);

export default withStyles(formGroupStyles)(FormGroup);
